import mergeModuleConfigs from 'core/utils/mergeModuleConfigs';
import { dynamicMerchant as orgConfig } from 'org/configs/modules.config';
import {
  RANDOM, RECOMMENDED, ALPHABETICAL, EARN_RATE,
} from 'core/modules/DynamicMerchants/utils/sortTypes';
import { DYNAMIC_MERCHANTS_GET_SUCCESS, DYNAMIC_MERCHANTS_GET_FAILURE } from '../actions/types';

const defaultConfig = {
  defaults: {
    api: {
      options: {
        success: DYNAMIC_MERCHANTS_GET_SUCCESS,
        failure: DYNAMIC_MERCHANTS_GET_FAILURE,
        cache: { isEnabled: true, isPublishedData: true },
        sectionId: 10225,
      },
      params: {
        sort_type: 'asc',
        sort_by: RECOMMENDED,
        content_type_id: 58,
        fields: [
          'id',
          'assets',
          'clickUrl',
          'merchant.id',
          'merchant.logoUrls',
          'merchant.rebate',
          'merchant.name',
          'merchant.showRebate',
          'merchant.offersCount',
          'merchant.categories',
        ],
      },
    },
    minMerchantsForSort: 13,
    checkShouldShowMenu: (shouldUseCarousel, merchantsNumberOnInitialLoad, minMerchantsForSort) => (
      !shouldUseCarousel && merchantsNumberOnInitialLoad >= minMerchantsForSort
    ),
    carousel: {
      breakpoints: {
        l: { hasDots: false, hasArrows: true },
      },
    },
    getExtraLabel: (logoTreatment) => (logoTreatment === 'small' ? 'Extra' : 'Extra miles'),
    shouldUseSortingButtons: true,
    sortingButtonsOptions: [
      { value: RECOMMENDED, label: () => 'Recommended' },
      { value: ALPHABETICAL, label: (isMobileMQ) => (isMobileMQ ? 'A-Z' : 'Alphabetical') },
      { value: EARN_RATE, label: (isMobileMQ) => (isMobileMQ ? 'Rate' : 'Earn rate') },
    ],
    sortingDropdownOptions: [
      { value: RECOMMENDED, label: 'Recommended' },
      { value: ALPHABETICAL, label: 'Alphabetical' },
      { value: EARN_RATE, label: 'Earn rate' },
    ],
  },
  sweeps: {
    api: {
      params: {
        offer_tag: 'sweeps-merchant-module-small-logo',
        sort_by: RANDOM,
        sort_type: null,
      },
    },
  },
};

export default mergeModuleConfigs(defaultConfig, orgConfig);
